import { useEffect, useState } from 'react'

const useSingleAndDoubleClick = (handleSingleClick, handleDoubleClick, delay = 250) => {
  const [click, setClick] = useState(0)

  useEffect(() => {
    const timer = setTimeout(() => {
      if (1 === click && 'function' === typeof handleSingleClick) {
        handleSingleClick()
      }

      if (2 === click && 'function' === typeof handleDoubleClick) {
        handleDoubleClick()
      }

      setClick(0)
    }, delay)

    return () => timer && clearTimeout(timer)
  }, [click, handleSingleClick, handleDoubleClick, delay])

  return event => setClick(event.detail)
}

export default useSingleAndDoubleClick
